import { useEffect, useMemo, useState } from 'react';

import { useAuthUser } from 'auth/hooks';
import { AlternateVersionHelper } from 'core/helpers';
import { PartDetails, PartDetailsTab } from 'parts/components/PartDetails';
import { IPart } from 'parts/types';
import { useSelectedQuotePartContext } from 'quotes/states';

interface IProps {
  isOpen: boolean;
  onClose: () => void;
  defaultTab?: PartDetailsTab;
}

export const VendorQuotePartDetails = ({ isOpen, onClose, defaultTab }: IProps) => {
  const { selectedQuotePart } = useSelectedQuotePartContext();
  const { user } = useAuthUser();

  const [part, setPart] = useState<IPart>(selectedQuotePart?.partArr);

  // Vendor quotes carry no alternate-version flag — use the logged-in company's setting.
  const isAlternateVersionEnabled = useMemo(
    () => AlternateVersionHelper.isAlternateVersionEnabled({ user }),
    [user]
  );
  const slidingPanelProps = useMemo(() => ({ autoWidth: true, interactive: true }), []);

  useEffect(() => {
    if (isOpen && selectedQuotePart?.partArr) {
      setPart(selectedQuotePart.partArr);
    }
  }, [isOpen, selectedQuotePart]);

  return (
    <PartDetails
      part={part}
      isOpen={isOpen}
      onClose={onClose}
      defaultTab={defaultTab}
      isAlternateVersionEnabled={isAlternateVersionEnabled}
      slidingPanelProps={slidingPanelProps}
    />
  );
};
